import React, { Component }     from "react";
import { Button, MenuItem, Modal, Row, Col } from "react-bootstrap";
import { FontAwesomeIcon }          from '@fortawesome/react-fontawesome'
import LoaderButton                 from "../../components/LoaderButton";
import { Colors }                   from "../../utils/Colors";
import { invokeGetAssessmentDetail} from "../../utils/AwsInvoke";
import { XYPlot,
          Crosshair,
          DiscreteColorLegend,
          FlexibleWidthXYPlot,
          HorizontalGridLines,
          LineSeries,
          LineMarkSeries,
          VerticalGridLines,
          SearchableDiscreteColorLegend,
          XAxis,
          YAxis }        from 'react-vis';
import { invokeGetClientAssessmentLowerBodyPowerReport } from "../../utils/AwsInvoke";

const axisProps = {
    tickSizeInner: 0,
    style: {line: {stroke: '#939393', strokeWidth: '1px'}}
};

const vertical_jump_color   = "#c22a2a";
const broad_jump_color    = "#6621c4";
const lateral_bound_left_color = "#2e78e7";
const lateral_bound_right_color     = "#fc9856";

const SPINALROM_LEGEND = [
    {title: 'All',  data: "all_data", color: "#000", strokeWidth: 14},
    {title: 'Vertical Jump',  data: "vertical_jump_data", color: vertical_jump_color, strokeWidth: 14},
    {title: 'Broad Jump', data: "broad_jump_data", color: broad_jump_color, strokeWidth: 14 },
    {title: 'Lateral Bound Left', data: "lateral_bound_left_data", color: lateral_bound_left_color, strokeWidth: 14 },
    {title: 'Lateral Bound Right', data: "lateral_bound_right_data", color: lateral_bound_right_color, strokeWidth: 14 },
];


var vertical_jump_data       = [];
var broad_jump_data          = [];
var lateral_bound_left_data  = [];
var lateral_bound_right_data = [];

var legend1_title  = "Vertical Jump";
var legend2_title  = "Broad Jump";
var legend3_title  = "Lateral Bound Left";
var legend4_title  = "Lateral Bound Right";

export default class AssessLowerBody extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading:       false,
            title:           "Lower Body Power Assessment",
            all_data:        true,
            crosshairValues: [],
        }
    }

    componentDidMount() {
        try {
            this.getClientData();
        } catch (e) {
            alert(e);
        }
    }

    resetDataVals () {
        vertical_jump_data                  = [];
        broad_jump_data                = [];
        lateral_bound_left_data  = [];
        lateral_bound_right_data = [];
    }

    getClientData = async () => {
        this.setState({
            loadingData: "Loading member data ... "
        })

        const results  = this.props.resultsLowerBodyPower;

        var asessInbodyChartData = [];
        var max_yaxis_val        = [];

        // Reset all vals in case someone clicks "All" multiple times; we don't want multiple duplicate vals
        this.resetDataVals();

        if(results) {
            var data            = results.data.lowerbody;
            var ctr = 0;

            var max_array = [];
            ////  BEGIN: BUILD OUT GRAPH DATA  ////
            for(var key in data) {
                var vertical_jump       = data[key].vertical_jump;
                var broad_jump          = data[key].broad_jump;
                var lateral_bound_left  = data[key].lateral_bound_left;
                var lateral_bound_right = data[key].lateral_bound_right;
                var date_created        = data[key].date_created;
                var date                = (new Date(date_created)).toLocaleString('en-US', { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' })

                vertical_jump_data.push({"x": date, "y": vertical_jump});
                broad_jump_data.push({"x": date, "y": broad_jump});
                lateral_bound_left_data.push({"x": date, "y": lateral_bound_left});
                lateral_bound_right_data.push({"x": date, "y": lateral_bound_right});

                // Get Max Value of All Data points and then filter out the highest value to use in the y-axis //
                max_array.push(vertical_jump, broad_jump, lateral_bound_left, lateral_bound_right)
            }

            this.setState({
                report_data: data.length,
                all_data: true,
                vertical_jump_data: vertical_jump_data,
                broad_jump_data: broad_jump_data,
                lateral_bound_left_data: lateral_bound_left_data,
                lateral_bound_right_data: lateral_bound_right_data
            })
        } else {
            //this.msgDataLoaded();
        }
    }

    onMouseLeave = () =>{
        this.setState({crosshairValues: []});
    }

    ////   Tooltip Hover   ////
    onNearestXTooltip = (value, {index}) => {
        var x   = vertical_jump_data[index].y;
        var x2  = vertical_jump_data[index].x;
        var y1  = broad_jump_data[index].y;
        var y2  = lateral_bound_left_data[index].y;
        var y3  = lateral_bound_right_data[index].y;

        this.setState({
                        crosshairValues: [{x: x2, y: y1}],
                        crossHairX:  x,
                        crossHairY1: y1,
                        crossHairY2: y2,
                        crossHairY3: y3
                      });
    };

    handleLegendClick = item => {
        var data = item.data;
        var dataset;

        if(data === "all_data")
            this.setState({
                all_data: false
            }, () => {
                this.getClientData();
            });
        else {
            if(data === "vertical_jump_data")            dataset = {"vertical_jump_data":vertical_jump_data};
            else if(data === "broad_jump_data")          dataset = {"broad_jump_data":broad_jump_data};
            else if(data === "lateral_bound_left_data")  dataset = {"lateral_bound_left_data":lateral_bound_left_data};
            else if(data === "lateral_bound_right_data") dataset = {"lateral_bound_right_data": lateral_bound_right_data};

            // Clear out all data since we're fiultering out datasets
            this.setState({
                all_data: false,
                current_dataset: data,
                vertical_jump_data: [],
                broad_jump_data: [],
                lateral_bound_left_data: [],
                lateral_bound_right_data: []
            }, function (){
                this.setState(dataset);
            })
        }
    };

    getAllTooltip () {
        return <span>
                    <span style={{display:"inline-block", verticalAlign:"top", width: "100%"}}>
                        <span style={{display: "block",fontSize:16}}>{ legend1_title }: {this.state.crossHairX} inches</span>
                        <span style={{display: "block",fontSize:16}}>{ legend2_title }: {this.state.crossHairY1} inches</span>
                        <span style={{display: "block",fontSize:16}}>{ legend3_title }: {this.state.crossHairY2} inches</span>
                        <span style={{display: "block",fontSize:16}}>{ legend4_title }: {this.state.crossHairY3} inches</span>
                    </span>
                </span>
    }

    // Show only 1 value in the tooltip hover //
    getSingleTooltip () {
        var dataset = this.state.current_dataset;
        var legend;
        var crosshair;
        if(dataset == "vertical_jump_data") {
            legend    = legend1_title;
            crosshair = this.state.crossHairX;
        } else if(dataset == "broad_jump_data") {
            legend    = legend2_title;
            crosshair = this.state.crossHairY1;
        } else if(dataset == "lateral_bound_left_data") {
            legend    = legend3_title;
            crosshair = this.state.crossHairY2;
        } else if(dataset == "lateral_bound_right_data") {
            legend    = legend4_title;
            crosshair = this.state.crossHairY3;
        }

        return <span>
                    <span style={{display:"inline-block", verticalAlign:"top", width: "100%"}}>
                        <span style={{display: "block",fontSize:16}}>{ legend }: { crosshair } inches</span>
                    </span>
                </span>
    }

    render() {
        var title     = this.state.title;
        var all_data  = this.state.all_data;
        var report_data  = this.state.report_data;
        var no_data_text;
        if(report_data === 0)  no_data_text  = <div style={{position:"relative", top: 75, padding: 15, fontSize:18}}>There is no assessment data.</div>

        var tooltip;
        var tooltip_width = 290;
        if(all_data) {
            tooltip_width = 350;
            tooltip       = this.getAllTooltip();
        } else {
            tooltip       = this.getSingleTooltip();
        }

        return (
            <div className="assessmentForm" style={{textAlign:"left"}}>
                <div className="iconAddExercise35pxVertSpacer"></div>
                <span style={{position:"relative", left:-10}}>
                        <div style={{fontSize:22, textAlign:"center"}}>
                            <FontAwesomeIcon icon="shoe-prints" style={{fontSize: '1.5em', paddingRight: 8 }}/>
                            <span style={{position:"relative", top:-4}}>
                                { title }
                                { no_data_text }
                            </span>
                        </div>
                        <span style={{display:"inline-block",width:"100%", border:"0px solid #000"}}>

                                <FlexibleWidthXYPlot height       = {200}
                                                     xType        = "ordinal"
                                                     yDomain      = {[0, 150]}
                                                     onMouseLeave = {this.onMouseLeave}
                                                     onMouseDown  = {() => {
                                                         //this.setState({showModalProgressDetail: true})
                                                        /*if (heldValue) {
                                                          this.setState({heldValue: false});
                                                          return;
                                                        }*/
                                                        //this.setState({heldValue: crosshairValues});
                                                      }}
                                                     >
                                  <VerticalGridLines />
                                  <HorizontalGridLines />

                                  <XAxis title="" {...axisProps}
                                         tickFormat={String}/>

                                     <YAxis title="Inches" {...axisProps}
                                         tickFormat={String} />

                                  <LineMarkSeries data={this.state.vertical_jump_data}       size={2.5} color={vertical_jump_color} onNearestX={this.onNearestXTooltip}/>
                                  <LineMarkSeries data={this.state.broad_jump_data}          size={2.5} color={broad_jump_color} onNearestX={this.onNearestXTooltip}/>
                                  <LineMarkSeries data={this.state.lateral_bound_left_data}  size={2.5} color={lateral_bound_left_color} onNearestX={this.onNearestXTooltip}/>
                                  <LineMarkSeries data={this.state.lateral_bound_right_data} size={2.5} color={lateral_bound_right_color} onNearestX={this.onNearestXTooltip}/>

                                  <Crosshair values={this.state.crosshairValues} >
                                      <div style={{float: "left", background: 'black', borderRadius: 5, width: tooltip_width, maxWidth: tooltip_width, borderRadius:5, padding: 10, zIndex: 1000}}>
                                          <span style={{display:"inline-block", width:"100%", fontSize:18, textAlign:"center"}}>{ title }</span>
                                             <br/>
                                             { tooltip }
                                      </div>
                                  </Crosshair>

                                </FlexibleWidthXYPlot>
                                { /**********  LEGEND  ***********/ }
                                <div style={{float: "left",  zIndex: 10}}>
                                    <DiscreteColorLegend items={SPINALROM_LEGEND}
                                                         orientation='horizontal'
                                                         onItemClick={this.handleLegendClick}
                                                         style={{display: "inline-block", position:"relative", width:900, top:-7, left:35}}/>

                                </div>
                        </span>
                 </span>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/report/AssessLowerBodyPower.js